import request from '@/request/request'


// 查询紧急求助列表
export function findAllPage(data) {
    return request({
        url: '/jk/resource-api/resource/Bailout/findAllPage',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8"
        }
    })
}

// 查询紧急求助详细
export function bailoutDetail(id) {
    return request({
        url: '/jk/resource-api/resource/Bailout/bailoutDetail',
        method: 'post',
        data: id,
        headers: {
            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8"
        }
    })
}

// 紧急求助处理
export function saveBailoutInfo(data) {
    return request({
        url: '/jk/resource-api/resource/Bailout/saveBailoutInfo',
        method: 'post',
        data: data
    })
}
// 紧急求助处理
export function findAllScenic(data) {
    return request({
        url: '/jk/resource-api/resource/findAllScenic',
        method: 'post',
        data: data,
        isFormData:true
    })
}

